import { apiDataManagerBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

const messagesApiRoutes = {
    list: apiDataManagerBaseURL + "messages",
    load: apiDataManagerBaseURL + "messages/",
    loadCreatedByAt: apiDataManagerBaseURL + "messages/createdByAt",
    create: apiDataManagerBaseURL + "messages",
    update: apiDataManagerBaseURL + "messages/",
    delete: apiDataManagerBaseURL + "messages/"
};

export class MessageAPI {
    static list(provider = '') {
        return API.authenticatedRequest({
            url: provider === '' ? messagesApiRoutes.list : `${messagesApiRoutes.list}?provider=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static load(id) {
        return API.authenticatedRequest({
            url: messagesApiRoutes.load + id,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static loadCreatedByAt() {
        return API.authenticatedRequest({
            url: messagesApiRoutes.loadCreatedByAt,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static create(message) {
        return API.authenticatedRequest({
            url: messagesApiRoutes.create,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(message)
        });
    }

    static update(id, message) {
        return API.authenticatedRequest({
            url: messagesApiRoutes.update + id,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(message)
        });
    }

    static delete(id) {
        return API.authenticatedRequest({
            url: messagesApiRoutes.delete + id,
            method: HTTPMethod.DELETE,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }
}
